<template>
    <div></div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            this.init();
        },
        data: function () {
            return {
                provider: this.$route.params.provider || null

            }
        },
        methods: {
            init: function () {
                eventBus.$emit('show-loader');

                let routeQuery = '';
                let routeQueryObj = this.$route.query;
                Object.keys(this.$route.query).map(function(objectKey, index) {
                    routeQuery = (routeQuery == '' ? '?' : (routeQuery + '&')) + objectKey + '=' + routeQueryObj[objectKey];
                });

                this.$http.get(this.apiUrl + '/login/social/callback/' + this.provider + routeQuery).then(function (response) {
                    this.loginUser(response.body);

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SocialLogin.vue